import React from 'react'
import './testimonial.css';
import avt from './../../asset/pexels-alexander-krivitskiy-1572878.jpg'
import avt1 from './../../asset/pexels-chloe-1043474.jpg'
import avt2 from './../../asset/pexels-italo-melo-2379004.jpg'
import avt3 from './../../asset/pexels-jorge-fakhouri-filho-2531127.jpg'
import avt4 from './../../asset/pexels-pixabay-415829.jpg'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination} from 'swiper';


// import Swiper and modules styles
import 'swiper/css';
// import 'swiper/dist/css/swiper.css'
// import 'swiper/dist/css/pagination';



const detail=[
  {
    avatar:avt1,
    name:"Rahul",
    review:' Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, officiis ipsum. Vero non minima neque molestiae optio reiciendis. Itaque laudantium consequuntur libero beatae explicabo vero doloribus totam, magni eius a eaque ipsa!'
  },
  {
    avatar:avt2,
    name:"anish",
    review:' Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, officiis ipsum. Vero non minima neque molestiae optio reiciendis. Itaque laudantium consequuntur libero beatae explicabo vero doloribus totam, magni eius a eaque ipsa!'
  },
  {
    avatar:avt3,
    name:"sakshi",
    review:' Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, officiis ipsum. Vero non minima neque molestiae optio reiciendis. Itaque laudantium consequuntur libero beatae explicabo vero doloribus totam, magni eius a eaque ipsa!'
  },
  {
    avatar:avt4,
    name:"Anamika",
    review:' Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, officiis ipsum. Vero non minima neque molestiae optio reiciendis. Itaque laudantium consequuntur libero beatae explicabo vero doloribus totam, magni eius a eaque ipsa!'
  }
]
function testimonial() {
  return (
    
  <Swiper id='testimonial'  spaceBetween={50}
  slidesPerView={1}  >
 
    
    {
      detail.map(({avatar,name,review})=>{

      return(
    <SwiperSlide className="container testimonial_container"  key={avatar}>
<div className="head_testimonial">
      <h5>Review from Client</h5>
    <h2>Testimonial</h2>
    </div>
      <article className="testimonal">
        <div className="client_avatar">
          <img src={avatar} alt="" />
        </div>
        <h5 className="client_name">{name}</h5>
        <small className="client_review">
          {review}
        </small>
      </article>
   
    </SwiperSlide>
      )})
}
  </Swiper>)
}

export default testimonial